var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCountryDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -46.2696,
    y1: 645.8383,
    x2: -27.5532,
    y2: 627.1208,
    gradientTransform: "matrix(21.3333 0 0 -21.3333 1000.6713 13791.667)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#369CDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AA56D0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M487.275,322.667l-101.333-152l102.72-154.091c2.176-3.264,2.389-7.467,0.533-10.944 C487.339,2.176,483.733,0,479.787,0h-448C25.899,0,21.12,4.779,21.12,10.667v320v170.667c0,5.888,4.779,10.667,10.667,10.667 s10.667-4.779,10.667-10.667v-160h437.333c0.128-0.021,0.277,0,0.427,0c5.888,0,10.667-4.779,10.667-10.667 C490.88,327.488,489.493,324.629,487.275,322.667z M42.453,320V21.333h417.408l-95.616,143.424c-2.389,3.584-2.389,8.256,0,11.84 L459.861,320H42.453z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryDark);
export default __webpack_public_path__ + "static/media/CountryDark.2b266c56.svg";
export { ForwardRef as ReactComponent };